import React, { Component } from 'react';
import Header from './Header';
import Movies from './Movie/Movies';

export default class App extends Component {

    constructor() {
        super();

        this.state = {
            title: 'ทั้งหมด'
        };
    }

    render() {
        return (
            <div>
                <Header title={this.props.title} />
                <div className="">
                    <Movies status={this.props.status} max={this.props.max} categoryId={this.props.categoryId}/>
                </div>
            </div>
        );
    }
}